const validators = {
  validateForm(self: Record<string, any>, formToValidate: string): void {
    self.$refs[formToValidate].validate((valid: unknown) => {
      self.formIsValid = valid;
      return valid;
    });
  },
};

export default validators;
